export default __webpack_public_path__ + "static/media/not-found.79d41431.gif";